import React, { createContext, useContext, useState, useCallback } from 'react';

const PageLoadingContext = createContext({
    isPageLoading: false,
    setPageLoading: () => { },
});

export const PageLoadingProvider = ({ children }) => {
    const [isPageLoading, setIsPageLoading] = useState(false);

    const setPageLoading = useCallback((loading) => {
        setIsPageLoading(loading);
    }, []);

    return (
        <PageLoadingContext.Provider value={{ isPageLoading, setPageLoading }}>
            {children}
        </PageLoadingContext.Provider>
    );
};

export const usePageLoading = () => useContext(PageLoadingContext);

export default PageLoadingContext;
